<template>
  <div class="position-relative" :class="'total-wrapper-' + theme" v-if="
    currentJewelSelection &&
    currentJewelSelection.suggestedJewels &&
    currentJewelSelection.suggestedJewels.length > 0
  ">
    <span :class="{'text-uppercase title-related ml-md-3': theme === 1, 'text-uppercase title-related-2 mt-3': theme === 2, 'ama-title-related': isAma}">{{
      $t("relatedJewels")
    }}</span>
    <!-- <swiper class="swiper" :options="swiperOptions">
      <swiper-slide
        :key="item.sku"
        v-for="item in currentJewelSelection.suggestedJewels"
      >
        <div
          class="w-100 parent-img cursor-pointer"
          v-on:click="selectJewel(item)"
        >
          <img :src="baseImageUrl + item.image" class="border-img" />

          <span class="jewel-name" v-if="position && item && item.minPrice">
            {{ item.descriptions[position].name }}
            <br />
            {{ item.minPrice.toFixed(2).replace(".", ",") }}€
          </span>
        </div></swiper-slide
      >
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper> -->
    <div v-swiper:mySwiper="swiperOptions">
      <div class="swiper-wrapper">
        <div class="swiper-slide cursor-pointer" :key="item.sku" v-for="item in currentJewelSelection.suggestedJewels"
          v-on:click="selectJewel(item)">
          <div class="w-100 p-2">
            <div :class="'parent-img-' + theme">
              <img :src="baseImageUrl + item.image"
                :class="['border-img-' + theme, item.category === 3 || item.category === 20 ? 'pendant-image' : '']" />

              <span class="jewel-name" v-if="position && item && item.minPrice && item.descriptions">
                {{ item.descriptions[position].name }}
                <br />
                €{{
                  parseFloat(item.minPrice * vat * retailPerc).toFixed(2).toLocaleString(
                    "it-it"
                  )
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";

export default {
  name: "RelatedJewels",
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      position: null,
      baseImageUrl: process.env.VUE_APP_IMAGE_PATH,
      swiperOptions: {
        loop: false,
        paginationClicakble: true,
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  computed: mapState({
    theme: (state) => state.config.theme,
    vat: (state) => state.detail.vat,
    retailPerc: (state) => state.detail.retailPerc,
    currentJewelSelection: (state) => state.detail.currentJewelSelection,
    isAma: (state) => state.config.isAma,
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  }),
  mounted() {
    this.getposition();
  },
  methods: {
    ...mapGetters("config", ["getCredential"]),
    ...mapMutations("detail", ["resetCurrentJewel", "resetDetail", "setPreselectedJewel"]),
    ...mapActions("detail", ["getListCategories"]),
    selectJewel(item) {
      this.resetDetail();
      this.resetCurrentJewel();
      this.setPreselectedJewel({});
      this.$router.push({
        params: {
          sku: item.sku,
          // type: this.$route.params.type,
          typeId: this.$route.params.typeId,
        },
      });
      setTimeout(() => {
        this.getListCategories("categories");
      }, 200);
    },
    getposition() {
      this.position = this.getCredential().locale;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.jewel-name {
  position: absolute;
  left: 0;
  right: 0;
  padding: 0px 50px;
  bottom: 20px;
  font-weight: normal;
  color: #3c3c3c;
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
}

.title-related {
  border-radius: 25px;
  background-color: var(--primary-color-1) !important;
  color: #fff !important;
  padding: 5px 40px;
  color: #fff;
  text-align: left;
  display: table;
  z-index: 999;
  margin-top: -20px;
  position: absolute;
}

.ama-title-related.title-related{
  border-radius: 5px;
}

.title-related-2 {
  color: var(--primary-color-1) !important;
  font-size: 25px;
  font-weight: bold;
}

.parent-img-1 {
  background-color: #ffff;
  padding: 20px;
}

.parent-img-2 {
  border-radius: 15px;
  background-color: #ffff;
  padding: 20px;
}

.border-img-1 {
  width: 100%;
  -moz-transform: scale(0.8);
  -webkit-transform: scale(0.8);
  transform: scale(0.8);
}

.pendant-image {
  margin-top: -25px;
  padding-bottom: 25px;
}

.border-img-2 {
  border-radius: 88px;
  width: 100%;
  -moz-transform: scale(0.8);
  -webkit-transform: scale(0.8);
  transform: scale(0.8);
}

@media only screen and (min-width: 768px) {
  .swiper-slide {
    padding-top: 25px;
    padding-bottom: 25px;
    padding: 0px 0px;
  }
}

@media only screen and (max-width: 768px) {
  .swiper-slide {
    margin-right: 0px !important;
    padding: 0px 10px;
  }

  .jewel-name {
    font-size: 13px;
    padding: 0px 20px;
    bottom: 20px;
  }

  .parent-img-1 {
    background-color: #ffff;
    padding: 0px;
    position: relative;
  }

  .parent-img-2 {
    border-radius: 88px;
    background-color: #ffff;
    padding: 0px;
    position: relative;
  }

  .title-related {
    font-size: 10px;
    padding: 4px 20px;
    margin-top: -10px;
  }

  .border-img {
    width: 100%;
    object-fit: cover;
    border-radius: 0%;
    // margin-bottom: 5px;
    // height: 200px;
    -moz-transform: scale(0.6);
    -webkit-transform: scale(0.6);
    transform: scale(0.6);
    // box-shadow: 0px 1px 4px 0px #707070;
  }
}

.total-wrapper-1 {
  background-color: #ebebeb;
}

.total-wrapper-2 {
  background-color: var(--secondary-color-1);
}

@media only screen and (max-width: 768px) {
  .total-wrapper-1 {
    background-color: #ebebeb;
    margin-top: 10px;
    // height: 100px;
  }

  .total-wrapper-2 {
    background-color: var(--secondary-color-1);
    margin-top: 10px;
    // height: 100px;
  }
}

.swiper-wrapper {
  padding-top: 30px;
  padding-bottom: 30px;
}

.swiper-button-next,
.swiper-button-prev {
  --swiper-navigation-color: #bbb;
  --swiper-navigation-size: 30px;

  &:hover {
    --swiper-navigation-color: #666;
  }
}
</style>
